import { useEffect, useState } from 'react'
import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Skeleton from '@mui/material/Skeleton'

const StandardSkeleton = () => {
    return <Box>
        <Card variant="outlined">
            <CardContent>
                <Skeleton variant="rectangular" width={210} height={118} animation="wave" />
                <Skeleton animation="wave" />
                <Skeleton width="60%" animation="wave" />
            </CardContent>
        </Card>

    </Box> 
}

export { StandardSkeleton }
export default StandardSkeleton;